module.exports = __webpack_public_path__ + "img/10.787f364e.jpg";